export default {
  ADMIN_NOTIFICATION_MGMT_LIST_REQUEST: 'APP/ADMIN_NOTIFICATION/ADMIN_NOTIFICATION_LIST_REQUEST',
  ADMIN_NOTIFICATION_MGMT_LIST_SUCCESS: 'APP/ADMIN_NOTIFICATION/ADMIN_NOTIFICATION_LIST_SUCCESS',
  ADMIN_NOTIFICATION_MGMT_LIST_ERROR: 'APP/ADMIN_NOTIFICATION/ADMIN_NOTIFICATION_LIST_ERROR',
};
